import React from 'react';
import Image from 'next/image';

import { BRANDING_LOGO_URL } from '@/const/branding';
import { MetaData } from '@/types_cp/meta';

export const DEFAULT_AVATAR = <Image src="/user-logo.png" alt="User" width={32} height={32} />;
export const DEFAULT_USER_AVATAR = <Image src="/user-logo.png" alt="User" width={32} height={32} />;
export const DEFAULT_ASSISTANT_AVATAR = (
  <Image src="/bot-logo.png" alt="OXU Copilot" width={32} height={32} />
);

export const DEFAULT_BACKGROUND_COLOR = 'rgba(0,0,0,0)';
export const DEFAULT_AGENT_META: MetaData = {};
export const DEFAULT_INBOX_AVATAR = (
  <Image src="/bot-logo.png" alt="OXU Copilot" width={32} height={32} />
);
export const DEFAULT_USER_AVATAR_URL = BRANDING_LOGO_URL || '/icons/icon-192x192.png';
